export const MainNav = [
    {
        icon: 'AiOutlineHome',
        type: 'item',
        label: 'Home',
        to: '/home',
        roles: ['administrador', 'aprobador', 'contratador', 'creador', 'reclutador']
    },
    {
        icon: 'AiOutlineUser',
        type: 'item',
        label: 'Perfil de Usuario',
        to: '/home/usuario',
        roles: ['administrador', 'aprobador', 'contratador', 'creador', 'reclutador']
    },
    {
        type: 'section',
        label: 'Talento Humano',
        roles: ['administrador', 'aprobador', 'contratador', 'creador', 'reclutador']
    },
    {
        icon: 'AiOutlineFileText',
        type: 'item',
        label: 'Proceso de Aprobaciones',
        to: '/home/procesos',
        // roles: [],
        roles: ['administrador', 'aprobador', 'creador']

    },
    {
        icon: 'AiOutlineMonitor',
        type: 'item',
        label: 'Proceso de Selección',
        to: '/home/proceso-seleccion',
        // roles: [],
        roles: ['administrador', 'reclutador']
    },
    {
        icon: 'AiOutlineFileProtect',
        type: 'item',
        label: 'Proceso de Contratación',
        to: '/home/proceso-contratacion',
        roles: [],
        roles: ['administrador', 'contratador']
    },
    {
        icon: 'AiOutlineClockCircle',
        type: 'item',
        label: 'Historico Solicitudes',
        to: '/home/historico',
        roles: ['administrador', 'contratador', 'creador', 'reclutador', 'aprobador']
    },
    {
        icon: 'AiOutlineSchedule',
        type: 'item',
        label: 'Gestión de contratos',
        to: '/home/prorrogas',
        roles: ['administrador', 'contratador']
        // roles: [ '8']
        // mails: ['david.ortiz@usantotomas.edu.co', 'talentohumano@confipetrol.com', 'contratacion.personal4@confipetrol.com', 'contratacion.personal2@confipetrol.com', 'auxiliar.th7@confipetrol.com', 'contratacion.personal1@confipetrol.com', 'contratacion.personal3@confipetrol.com']
    },
    {
        icon: 'AiOutlineDollarCircle',
        type: 'item',
        label: 'Reporte a Nómina',
        to: '/home/nomina',
        roles: ['administrador']
        // roles: [ '8']
        // mails: ['david.ortiz@usantotomas.edu.co', 'talentohumano@confipetrol.com', 'contratacion.personal4@confipetrol.com', 'contratacion.personal2@confipetrol.com', 'auxiliar.th7@confipetrol.com', 'contratacion.personal1@confipetrol.com', 'contratacion.personal3@confipetrol.com']
    },
    {
        type: 'section',
        label: 'Vinculación de Personal',
        roles: ['administrador', 'aprobador', 'contratador', 'creador', 'reclutador']
    },
    {
        icon: 'AiOutlineFileProtect',
        type: 'item',
        label: 'Fecha Contratación',
        to: '/home/confirmarFechaContratacion',
        roles: ['administrador', 'contratador', 'aprobador', 'creador']
    },
    {
        icon: 'AiOutlineFileProtect',
        type: 'item',
        label: 'Cargue Contrato',
        to: '/home/cargueContrato',
        roles: ['administrador', 'contratador', 'aprobador', 'creador']
    },
    {
        type: 'section',
        label: 'Desvinculación de Personal',
        roles: ['administrador', 'aprobador', 'contratador', 'creador', 'reclutador']
    },
    
    {
        icon: 'AiOutlineFileProtect',
        type: 'item',
        label: 'Proceso paz y salvo',
        to: '/home/retiros',
        // roles: ['6']
        roles: ['administrador']
    },
    {
        type: 'section',
        label: 'Otros',
        roles: ['administrador']
    },
    {
        icon: 'AiOutlineUsergroupAdd',
        type: 'item',
        label: 'Gestión de Usuarios',
        to: '/home/usuarios',
        // roles: []
        mails: ['ordavid@confipetrol.com', 'director.nomina@confipetrol.com', 'yurimarcela4@gmail.com', 'achermes@confipetrol.com']
    },
    {
        icon: 'AiOutlineMail',
        label: 'Envio de Correo Masivo',
        type: 'item',
        to: '/home/mail-manager',
        // roles: ['6'],
        mails: ['ordavid@confipetrol.com', 'gestor.bienestar@confipetrol.com', 'director.nomina@confipetrol.com', 'soporte.bienestar@confipetrol.com', 'achermes@confipetrol.com']
    },
    {
        icon: 'AiOutlineFileText',
        label: 'Informe APE',
        type: 'item',
        to: '/home/informe-ape',
        roles: ['administrador']
    },
    {
        icon: 'CgLogOut',
        type: 'logout',
        label: 'Cerrar Sesión',
        roles: ['administrador', 'aprobador', 'contratador', 'creador', 'reclutador']
    },
    
];